import {
  Tooltip as ChakraTooltip,
  TooltipProps as ChakraTooltipProps,
} from '@chakra-ui/react';

import Text from '../Text';

export interface TooltipProps extends ChakraTooltipProps {
  description: string | React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  description,
  ...props
}) => {
  return (
    <ChakraTooltip
      bg="grey.800"
      borderRadius="radius-8"
      hasArrow
      label={
        typeof description === 'string' ? (
          <Text color="white" fontSize="font-13" fontWeight="weight-400">
            {description}
          </Text>
        ) : (
          description
        )
      }
      paddingX="space-8"
      paddingY="space-4"
      placement="top"
      {...props}
    >
      {children}
    </ChakraTooltip>
  );
};

export default Tooltip;
